import { ApiServiceV2 } from "@sunrise-upc/ajax-lib";

export interface LoginBasicPropConfigSchema {
  baseURL: string | "";
}
export class LoginBasicPropConfig {
  private static instance: LoginBasicPropConfig;
  apiServiceObject?: ApiServiceV2;
  prop: any;
  config: LoginBasicPropConfigSchema = {
    baseURL: "",
  };

  private constructor(p_config: LoginBasicPropConfigSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? "";
  };

  public static getInstance = (): LoginBasicPropConfig => {
    return LoginBasicPropConfig.instance;
  };
  public static create = (p_config: LoginBasicPropConfigSchema): void => {
    LoginBasicPropConfig.instance = new LoginBasicPropConfig(p_config);
  };

  getAPIServiceObject = (): ApiServiceV2 => {
    if (!this.apiServiceObject) {
      const propsV2 = {
        options: undefined,
        props: {
          incCsrf: true,
          baseUrl: this.getBaseUrl(),
        },
      };
      this.apiServiceObject = ApiServiceV2.getApiServiceInstance(propsV2);
    }
    return this.apiServiceObject;
  };
}
